<template>
  <div class="w-16 rounded-lg shadow-md p-1 cursor-pointer m-1 bg-green-500 hover:bg-green-lightest" v-on:click="click">
    <div class="font-semibold text-blue-darker my-2">
      <span class="text-2xl">{{ numero }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["numero"],
  methods: {
    click() {
      this.$emit("clickeado", this.numero);
    }
  }
};
</script>
